const CircleOutlinedIcon = props => (
	<svg
		className="circle-outlined-icon"
		width="15"
		height="15"
		viewBox="0 0 15 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx="7" cy="7.92773" r="6" stroke="currentColor" strokeWidth="2" />
	</svg>
);

export default CircleOutlinedIcon;
